import { render, staticRenderFns } from "./ExportFormatCard.vue?vue&type=template&id=585d7326&scoped=true&"
import script from "./ExportFormatCard.vue?vue&type=script&lang=js&"
export * from "./ExportFormatCard.vue?vue&type=script&lang=js&"
import style0 from "./ExportFormatCard.vue?vue&type=style&index=0&id=585d7326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d7326",
  null
  
)

export default component.exports